// src/components/Services.jsx (Landing Page Component)

import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom'; // Import Link for navigation
import ServiceCard from './ServiceCard';
import servicesData from '../data/servicesData';
import { IoArrowForward } from 'react-icons/io5'; // Optional: Import an icon for the button

const Services = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <section id="services" className="py-20 bg-gray-50">
            <div className="container mx-auto px-4">
                <motion.div
                    ref={ref}
                    initial={{ opacity: 0, y: 20 }}
                    animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl font-bold text-arcdom-navy mb-4">Our Services</h2>
                    <div className="w-20 h-1 bg-arcdom-gold mx-auto mb-6"></div>
                    <p className="max-w-2xl mx-auto text-gray-600">
                        Providing exceptional construction and development services since 2007.
                        Quality, reliability, and customer satisfaction are at the heart of everything we do.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {servicesData.map((service, index) => (
                        <ServiceCard
                            key={index}
                            icon={service.icon}
                            title={service.title}
                            description={service.description}
                            delay={index * 0.2}
                        />
                    ))}
                </div>

                {/* Explore Our Services Button */}
                <div className="text-center mt-16">
                    <Link
                        to="/services"
                        className="inline-flex items-center px-8 py-3 border-2 border-arcdom-navy text-arcdom-navy rounded-md font-semibold hover:bg-arcdom-navy hover:text-white transition-colors duration-300 text-lg"
                    >
                        Explore Our Services
                        <IoArrowForward className="ml-2 w-5 h-5" /> {/* Optional Icon */}
                    </Link>
                </div>

            </div>
        </section>
    );
};

export default Services;
